var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightDetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 12.8711C2.5 18.3938 6.97727 22.8711 12.5 22.8711C18.0227 22.8711 22.5 18.3938 22.5 12.8711C22.5 7.34836 18.0227 2.87109 12.5 2.87109C6.97727 2.87109 2.5 7.34837 2.5 12.8711ZM10.4936 15.8647C10.328 16.0362 10.2364 16.2658 10.2385 16.5042C10.2405 16.7425 10.3362 16.9706 10.5047 17.1391C10.6733 17.3077 10.9013 17.4033 11.1396 17.4053C11.378 17.4074 11.6076 17.3158 11.7791 17.1502L15.4155 13.5138C15.5859 13.3433 15.6816 13.1122 15.6816 12.8711C15.6816 12.63 15.5859 12.3988 15.4155 12.2284L11.7791 8.592C11.6076 8.4264 11.378 8.33477 11.1396 8.33684C10.9013 8.33891 10.6733 8.43452 10.5047 8.60308C10.3362 8.77163 10.2405 8.99964 10.2385 9.238C10.2364 9.47636 10.328 9.706 10.4936 9.87746L13.4873 12.8711L10.4936 15.8647Z",
    fill: "#CF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightDetail);
export default __webpack_public_path__ + "static/media/chevron-right-detail.53fb895c4fd941438aea010cbf1e3366.svg";
export { ForwardRef as ReactComponent };